import React from 'react';

import { Metadata } from '@/types/metadata';
import { getCanonicalPageUrl, isBuyFishPageUrl } from '@/utils/url';

type Props = {
	metadata: Metadata;
	pageUrl: string;
};

export const HeadWithMetaDataGlobal = ({ metadata, pageUrl }: Props): React.ReactElement[] => {
	const { imageUrl } = metadata;
	const baseUrl = (process.env.HOST || 'https://fishplace.ru').replace(/\/+$/, '');
	const previewImageUrl = imageUrl.replace('webp', 'jpg').replace('https://fishplace.ru', baseUrl);
	const isBuyFishPage = isBuyFishPageUrl(pageUrl);
	const canonicalUrl = `${baseUrl}${getCanonicalPageUrl(pageUrl)}`;

	const AdditionalTags = (): React.ReactElement[] => {
		if (!metadata.additionalTags?.length) return [];

		return metadata.additionalTags.map((tag) => {
			const key = [tag.name, ...Object.entries(tag.attributes).flat()].join('-');
			return React.createElement(tag.name, {
				...tag.attributes,
				key,
			});
		});
	};

	return [
		<title key="title">{metadata.title}</title>,
		<meta key="description" name="description" content={metadata.description} />,
		<meta
			key="width=device-width, initial-scale=1"
			name="viewport"
			content="width=device-width, initial-scale=1"
		/>,
		<link key="/favicon.ico" rel="icon" href="/favicon.ico" />,
		<link key="canonical" rel="canonical" href={canonicalUrl} />,
		<meta key="og:title" property="og:title" content={metadata.title} />,
		<meta key="og:type" property="og:type" content={isBuyFishPage ? 'product' : 'website'} />,
		<meta key="og:locale" property="og:locale" content="ru_RU" />,
		<meta key="og:description" property="og:description" content={metadata.description} />,
		<meta key="og:image" property="og:image" content={previewImageUrl} />,
		<meta key="og:image:secure_url" property="og:image:secure_url" content={previewImageUrl} />,
		<meta key="og:image:type" property="og:image:type" content="image/jpeg" />,
		<meta key="og:url" property="og:url" content={canonicalUrl} />,
		<meta key="fishplace.ru" property="og:site_name" content="fishplace.ru" />,
		<meta key="summary_large_image" name="twitter:card" content="summary_large_image" />,
		<meta key="twitter:title" content={metadata.title} />,
		<meta key="twitter:description" name="twitter:description" content={metadata.description} />,
		<meta key="twitter:image" name="twitter:image" content={previewImageUrl} />,
		<meta key="twitter:url" name="twitter:url" content={canonicalUrl} />,
		...AdditionalTags(),
	];
};
